import {
  createApi,
  FetchArgs,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { baseUrl } from "../../constants/baseUrl";
import { keycloakService } from "../../services/keycloakService";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: `${baseUrl}/v1/`,
  prepareHeaders: (headers, { endpoint, type }) => {
    // Get token from Keycloak service
    const token = keycloakService.getToken();

    // If we have a token, add it to headers
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    // Don't set Content-Type for file upload endpoints - let browser handle it
    if (endpoint !== "bulkUploadMembers") {
      headers.set("Content-Type", "application/json");
    }

    return headers;
  },
});

// wrap the baseQuery
const customBaseQuery = async (
  args: string | FetchArgs,
  api: any,
  extraOptions: any,
) => {
  // Try to refresh token before making the request
  try {
    await keycloakService.updateToken(30);
  } catch (error) {
    console.log("Token refresh failed:", error);
  }

  // Make the API call
  let result = await rawBaseQuery(args, api, extraOptions);

  // Handle 401 unauthorized errors
  if (result.error?.status === 401) {
    console.log("Token expired or invalid - trying to refresh");

    // Try to refresh token
    try {
      const refreshed = await keycloakService.updateToken(0);
      if (refreshed) {
        console.log("Token refreshed successfully, retrying request");
        // Retry the original request with new token
        result = await rawBaseQuery(args, api, extraOptions);
      } else {
        console.log("Token refresh failed - user needs to login again");
      }
    } catch (refreshError) {
      console.log("Token refresh error:", refreshError);
    }
  }

  return result;
};

export const api = createApi({
  reducerPath: "api",
  baseQuery: customBaseQuery, // Change baseUrl as needed
  endpoints: () => ({}),
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 200000,
  tagTypes: [
    "dashboard",
    "members",
    "events",
    "users",
    "ssl",
    "pendingMembers",
    "payment",
    "paymentSummary",
    "bkashPayments",
    "activities",
    "MembershipType",
    "MemberFee",
    "registeredEvents",
    "upcomingEvents",
    "Participants",
    "Country",
    "Notification",
    "UnreadCount",
    "bkashSubscription",
  ],
});

export const {} = api;
